import { Service } from '../config'

class InspectionAccessoriesService extends Service {
  path = 'vistoria'

  async getInspectionAccessories(id: string) {
    const httpResponse = await this.httpClient.get(`${this.path}/obteracessoriosselecionados?vistoriaId=${id}`)
    return httpResponse
  }
}

export const inspectionAccessoriesService = new InspectionAccessoriesService()
